<div class="trunk-show-manager">
  <h3>TRUNK SHOW EVENTS</h3>
  <p class="hint">
    Trunk show discounts are only available while the event is active. They are not permanently attached to a vendor.
  </p>

  <div class="draft-row">
    <mat-form-field>
      <mat-label>NAME</mat-label>
      <input matInput [(ngModel)]="draft.name" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>VENDOR / LINE</mat-label>
      <input matInput [(ngModel)]="draft.vendorName" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>START</mat-label>
      <input matInput type="date" [(ngModel)]="draft.startDate">
    </mat-form-field>
    <mat-form-field>
      <mat-label>END</mat-label>
      <input matInput type="date" [(ngModel)]="draft.endDate">
    </mat-form-field>
    <mat-form-field>
      <mat-label>DISCOUNT %</mat-label>
      <input matInput type="number" [(ngModel)]="draft.discountPercent">
    </mat-form-field>
    <button mat-raised-button type="button" [disabled]="saving" (click)="add()">ADD EVENT</button>
  </div>

  <div class="event-card" *ngFor="let event of events">
    <mat-form-field>
      <mat-label>NAME</mat-label>
      <input matInput [(ngModel)]="event.name">
    </mat-form-field>
    <mat-form-field>
      <mat-label>VENDOR / LINE</mat-label>
      <input matInput [(ngModel)]="event.vendorName">
    </mat-form-field>
    <mat-form-field>
      <mat-label>DISCOUNT %</mat-label>
      <input matInput type="number" [(ngModel)]="event.discountPercent">
    </mat-form-field>
    <button mat-stroked-button type="button" [disabled]="saving" (click)="save(event)">SAVE</button>
  </div>
</div>
